import {BurningTaskList} from "./views/burning-task-list";
import Store from "./api/store";
import {Task} from "./views/task";
import {Presenter} from "./presenter";
import {CurrentTaskList} from "./views/current-task-list";
import {TodayTaskList} from "./views/today-task-list";
import {TodayTask} from "./views/today-task";
import {FavoriteTaskList} from "./views/favorite-task-list";
import {FavoriteTask} from "./views/favorite-task";
import {AllTaskList} from "./views/all-task-list";
import {AllTask} from "./views/all-task";
import {Api} from "../api/api";
import {QueueTaskList} from "./views/queue-task-list";
import {QueueTask} from "./views/queue-task";
import {OneTask} from "./views/one-task";
import {SubTaskList} from "./views/sub-task-list";
import {SubTask} from "./views/sub-task";
import {FlatpickrFn} from "flatpickr/dist/types/instance";
import {AbstractItem} from "./views/abstract-task";

export enum ListType {
  BURNING  = `burning`,
  CURRENT  = `current`,
  TODAY    = `today`,
  FAVORITE = `favorite`,
  ALL      = `all`,
  QUEUE    = `queue`,
  ONE_TASK = `one-task`,
  SUB_TASK = `sub-task`,
}

const deadlineEdit = (flatpickr: FlatpickrFn) => {
  const taskStore = new Store(`tasks`, {burning: {}, current: {}, favorite: {}, today: {}, all: {}, queue: {}});

  const api = new Api();

  const burningListElement: HTMLElement | null = document.querySelector(`[data-tasks-list-type="${ListType.BURNING}"]`);
  const currentListElement: HTMLElement | null = document.querySelector(`[data-tasks-list-type="${ListType.CURRENT}"]`);
  const todayListElement: HTMLElement | null = document.querySelector(`[data-tasks-list-type="${ListType.TODAY}"]`);
  const favoriteListElement: HTMLElement | null = document.querySelector(
    `[data-tasks-list-type="${ListType.FAVORITE}"]`);
  const allTasksListElement: HTMLElement | null = document.querySelector(`[data-tasks-list-type="${ListType.ALL}"]`);
  const queueTaskListElement: HTMLElement | null = document.querySelector(`[data-tasks-list-type="${ListType.QUEUE}"]`);
  const oneTaskPageElement: HTMLElement | null = document.querySelector(
    `[data-tasks-list-type="${ListType.ONE_TASK}"]`);
  const subTaskListElement: HTMLElement | null = document.querySelector(
    `[data-tasks-list-type="${ListType.SUB_TASK}"]`);

  const burningListView = burningListElement && new BurningTaskList(burningListElement);
  const currentListView = currentListElement && new CurrentTaskList(currentListElement);
  const todayListView = todayListElement && new TodayTaskList(todayListElement);
  const favoriteListView = favoriteListElement && new FavoriteTaskList(favoriteListElement);
  const allTasksListView = allTasksListElement && new AllTaskList(allTasksListElement);
  const queueTasksListView = queueTaskListElement && new QueueTaskList(queueTaskListElement);
  const subTasksListView = subTaskListElement && new SubTaskList(subTaskListElement);

  const initTaskView = (task, type: ListType): AbstractItem => {
    let taskView: AbstractItem;

    if (type === ListType.TODAY) {
      taskView = new TodayTask(task, flatpickr, type);
    } else if (type === ListType.FAVORITE) {
      taskView = new FavoriteTask(task, flatpickr, type);
    } else if (type === ListType.ALL) {
      taskView = new AllTask(task, flatpickr, type);
    } else if (type === ListType.QUEUE) {
      taskView = new QueueTask(task, flatpickr, type);
    } else if (type === ListType.ONE_TASK) {
      taskView = new OneTask(task, flatpickr, type);
    } else if (type === ListType.SUB_TASK) {
      taskView = new SubTask(task, flatpickr, type);
    } else taskView = new Task(task, flatpickr, type);

    taskView.init();
    taskStore.setItem(task.dataset.id, taskView, type);

    return taskView;
  };

  burningListElement && burningListView?.getItems()
    .forEach((task) => initTaskView(task, ListType.BURNING));

  currentListElement && currentListView?.getItems()
    .forEach((task) => initTaskView(task, ListType.CURRENT));

  todayListElement && todayListView?.getItems()
    .forEach((task) => initTaskView(task, ListType.TODAY));

  favoriteListElement && favoriteListView?.getItems()
    .forEach((task) => initTaskView(task, ListType.FAVORITE));

  allTasksListElement && allTasksListView?.getItems()
    .forEach((task) => initTaskView(task, ListType.ALL));

  queueTaskListElement && queueTasksListView?.getItems()
    .forEach((task) => initTaskView(task, ListType.QUEUE));

  subTaskListElement && subTasksListView?.getItems()
    .forEach((task) => initTaskView(task, ListType.SUB_TASK));

  oneTaskPageElement && initTaskView(oneTaskPageElement, ListType.ONE_TASK);

  const presenter = new Presenter(taskStore, api, flatpickr, burningListView, currentListView);
  presenter.init();

  window.taskEmitter.on(`task/addQueue`, (selector: string) => {
    const newTasks = queueTasksListView?.addNewTasks(selector);

    if (newTasks?.length) {
      newTasks.forEach((task) => {
        const view = initTaskView(task, ListType.QUEUE);

        window.taskEmitter.emit(`task/initAddedQueue`, view.getId(), view);
      });
    }
  });
};

export default deadlineEdit;
